/**
 * Burundian franc.
 */
export var BIF = {
  code: 'BIF',
  base: 10,
  exponent: 0
};